module.exports = __webpack_public_path__ + "img/treeview.151f60db.svg";